import React, { useState, useEffect } from 'react';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import Login from './components/Login';
import Signup from './components/Signup';
import Dashboard from './components/Dashboard';
import Landing from './components/Landing';
import { FeedbackHost } from './components/feedback';
import { LoadingScreen, Icon } from './components/ui';
import './components/Auth.css';
import { hideSplash, onAppLink } from './native';
import { rememberArrival } from './arrival';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  // landing, then Log in or Sign up on their own screen (design F31).
  const [view, setView] = useState('landing');
  // ?invite= / ?ref=share, kept through sign-up (brief 035).
  useState(() => rememberArrival());

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      // Logging out lands on the landing page, not the Log in form used before.
      if (!currentUser) setView('landing');
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // Signed out: the sign-in page is the first real screen. (Signed in, Dashboard hides
  // the splash once the profile is there.)
  useEffect(() => { if (!loading && !user) hideSplash(); }, [loading, user]);

  // iPhone app, signed out: a medxmeet.com link with ?invite= or ?ref= (brief 036)
  // reopens the app at that address, so Landing and Sign up read it as on the website.
  useEffect(() => {
    if (loading || user) return;
    return onAppLink(url => {
      const wanted = ['invite', 'ref'].some(k => url.searchParams.has(k));
      if (wanted && window.location.search !== url.search) window.location.assign('/' + url.search);
    });
  }, [loading, user]);

  useEffect(() => { window.scrollTo(0, 0); }, [view]);

  if (loading) return <LoadingScreen />;

  if (user) {
    return <><Dashboard user={user} /><FeedbackHost /></>;
  }

  if (view === 'landing') return (
    <><Landing onSignIn={() => setView('login')} onSignUp={() => setView('signup')} /><FeedbackHost /></>
  );

  return (
    <div className="auth-screen">
      <div className="auth-screen-bar">
        <button className="auth-screen-back" onClick={() => setView('landing')}><Icon name="back" size={20} />MedXMeet</button>
      </div>
      {view === 'login'
        ? <Login onSwitchToSignup={() => setView('signup')} />
        : <Signup onSwitchToLogin={() => setView('login')} />}
      <FeedbackHost />
    </div>
  );
}

export default App;